export default __webpack_public_path__ + "static/media/map.dfe22303.png";